module.exports = __webpack_public_path__ + "img/DE02633.48fb03f6.png";